import { mapState } from 'vuex';
import { handleLocalStorage } from '@/assets/js/utils';
export default {
  props: {
    nickName: {
      type: [String, Number],
      default: ''
    },
    rtc: {
      type: Object,
      default: () => {}
    },
    devicesInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    rtilCode: {
      type: Number,
      default: 0
    },
    localVolume: {
      type: Number,
      default: 0
    },
    mic: {
      type: Boolean,
      default: true
    },
    rtcLoaded: {
      type: Boolean,
      default: false
    },
    speaker: {
      type: Boolean,
      default: true
    },
    microphoneDevice: {
      type: Array,
      default: () => []
    },
    speakerDevice: {
      type: Array,
      default: () => []
    },
    selectSessionInfo: {
      type: Object,
      default: () => {}
    },
    talentList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    returnEnablePushTalk() {
      const routeName = this.$route.name;
      if (routeName == 'station') {
        return !this.selectSessionInfo.status;
      } else {
        return !this.selectSessionInfo.intercomSessionId;
      }
    },
    returnEnabledTalkToAllTalents() {
      return !!this.selectSessionInfo.intercomSessionId;
    }
  },
  data() {
    return {
      audiSettingInfo: {
        title: 'common.audioAdvancedSettings',
        show: false,
        cancel: 'start.cancel',
        save: 'Movepips.save'
      },
      audioSettingList: [{
        type: 'AEC',
        checked: false,
        i18n: 'common.aecTips',
        localKey: 'checkedAec'
      }, {
        type: 'ANS',
        checked: false,
        i18n: 'common.ansTips',
        localKey: 'checkedAns'
      }, {
        type: 'AGC',
        checked: false,
        i18n: 'common.agcTips',
        localKey: 'checkedAgc'
      }, {
        type: 'STEREO',
        checked: false,
        i18n: 'common.stereoTips',
        localKey: 'checkedStereo'
      }],
      nickNameInputVal: '',
      hasClickRename: false,
      showPopover: false,
      pressUpTime: 0,
      pressDownTime: 0,
      delayTimer: null,
      talkToHost: false,
      lastOperationTime: 0
    };
  },
  methods: {
    controlAudio(val) {
      this.$emit('eventCallback', {
        type: 'controlAudio',
        val
      });
    },
    controlSpeaker(val) {
      this.$emit('eventCallback', {
        type: 'controlSpeaker',
        val
      });
    },
    changeDevice(info) {
      this.$emit('eventCallback', {
        type: 'changeDevice',
        val: info
      });
    },
    isQuickluOperation() {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastOperationTime < 500) {
        return true;
      } else {
        this.lastOperationTime = currentTime;
        return false;
      }
    },
    controlTalkToAllTalents() {
      if (!this.talentList.length) return;
      this.$emit('eventCallback', {
        type: 'controlTalkToAllTalents'
      });
    },
    controlTalkToHost(val) {
      if (!this.selectSessionInfo.intercomSessionId) {
        if (val) this.$message.warning(this.$t('intercom.noSession'));
        return;
      }
      const isQuickluOperation = this.isQuickluOperation();
      if (isQuickluOperation) return;
      this.talkToHost = !this.talkToHost;
      this.$emit('eventCallback', {
        type: 'controlTalkToHost',
        val: this.talkToHost
      });
    },
    updateDeviceId(type, info) {
      if (type == 'audio') {
        this.devicesInfo.microphoneId = info;
      } else {
        this.devicesInfo.speakerId = info;
      }
    },
    showAudioSetting() {
      this.audiSettingInfo.show = true;
    },
    changeMute(val) {
      this.$emit('eventCallback', {
        type: 'changeMute',
        val
      });
    },
    turnTips(flag, tag) {
      // 无摄像头
      let msg = '';
      if (tag === 'camera' && !this.devicesInfo.cameraId || tag === 'microphone' && !this.devicesInfo.microphoneId) {
        msg = 'No access';
      } else {
        const onOroff = flag ? this.$t('operationBtn.off') : this.$t('operationBtn.on');
        msg = `${onOroff} ${tag}`;
      }
      return msg;
    },
    setAduioSetting(type) {
      const AEC = handleLocalStorage('get', 'checkedAec') || true;
      const ANS = handleLocalStorage('get', 'checkedAns') || true;
      const AGC = handleLocalStorage('get', 'checkedAgc') || true;
      const STEREO = handleLocalStorage('get', 'checkedStereo');
      if (type === 'save') {
        this.audioSettingList.forEach(item => {
          handleLocalStorage('set', item.localKey, item.checked);
        });
        window.location.reload();
      } else {
        this.audioSettingList.forEach(item => {
          switch (item.type) {
            case 'AEC':
              item.checked = JSON.parse(AEC);
              break;
            case 'ANS':
              item.checked = JSON.parse(ANS);
              break;
            case 'AGC':
              item.checked = JSON.parse(AGC);
              break;
            case 'STEREO':
              item.checked = JSON.parse(STEREO);
              break;
          }
        });
      }
    },
    async copyUserId() {
      this.showPopover = false;
      await navigator.clipboard.writeText(this.nickName || this.rtilCode);
      this.$message.success(this.$t('aiSpeech.copySuccess'));
    },
    saveNickname() {
      if (!this.nickNameInputVal) {
        this.$message.error(this.$t('common.nameIsRequired'));
        return;
      }
      this.hasClickRename = false;
      const params = [{
        mark: this.State.partyJoinInfo.rtilCode + '',
        annotation: this.State.partyJoinInfo.joinCode,
        key: 'nickName',
        value: this.nickNameInputVal,
        notify: true,
        initiator: this.State.partyJoinInfo.rtilCode
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$emit('eventCallback', {
            type: 'changeNickName',
            val: this.nickNameInputVal
          });
        }
      });
    },
    showRenameInput() {
      this.hasClickRename = true;
      this.showPopover = false;
      this.$nextTick(() => {
        this.nickNameInputVal = this.nickName;
        this.$refs.nickNameInput.focus();
        this.$refs.nickNameInput.select();
      });
    }
  }
};